var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mini-card",
    class: [("mini-card_" + (_vm.size))]
  }, [_vm.backIcon ? _c('div', {
    staticClass: "mini-card__back-icon",
    on: {
      "click": function ($event) {
        return _vm.emit('back');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.image ? _c('div', {
    staticClass: "mini-card__photo-wrapper"
  }, [_c('img', {
    staticClass: "mini-card__photo",
    attrs: {
      "src": _vm.image,
      "alt": _vm.name
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mini-card__content"
  }, [_c('div', {
    staticClass: "mini-card__name"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mini-card__price"
  }, [_vm._v("\n      " + _vm._s(_vm.price) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }